import usertour from 'usertour.js';
import type { Attributes, EventAttributes } from 'usertour.js';

interface InitOptions {
  host?: string;
}

let isEnabled = false;
let identifyPromise: Promise<void> | null = null;

function configureSelfHostedEndpoints(host: string) {
  const baseUrl = host.replace(/\/+$/, '');
  window.USERTOURJS_ENV_VARS = {
    WS_URI: `${baseUrl}/`,
    ASSETS_URI: `${baseUrl}/sdk/`,
    USERTOURJS_ES2020_URL: `${baseUrl}/sdk/es2020/usertour.js`,
    USERTOURJS_LEGACY_URL: `${baseUrl}/sdk/legacy/usertour.iife.js`,
  };
}

export const usertourService = {
  init(token: string | undefined, opts?: InitOptions) {
    if (!token) {
      isEnabled = false;
      return;
    }
    try {
      if (opts?.host) {
        configureSelfHostedEndpoints(opts.host);
      }
      usertour.init(token);
      isEnabled = true;
    } catch {
      isEnabled = false;
    }
  },

  identify(userId: string, attrs: Attributes): Promise<void> | void {
    if (!isEnabled) return;
    try {
      const promise = usertour.identify(userId, attrs);
      identifyPromise = Promise.resolve(promise).catch(() => {
        identifyPromise = null;
      });
      return identifyPromise;
    } catch {
      identifyPromise = null;
    }
  },

  track(event: string, props?: EventAttributes): Promise<void> | void {
    if (!isEnabled) return;
    if (!identifyPromise) return;
    return identifyPromise
      .then(() => {
        if (!usertour.isIdentified()) return;
        return usertour.track(event, props);
      })
      .catch(() => {});
  },

  reset() {
    if (!isEnabled) return;
    identifyPromise = null;
    try {
      usertour.reset();
    } catch {
      identifyPromise = null;
    }
  },

  getIsEnabled: () => isEnabled,
};
